import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Badge from 'react-bootstrap/Badge';
import Marquee from "react-fast-marquee";

function Skills() {

   const aboutContent = "I’m a UI/UX Designer & Frontend Developer with 4.5+ years of experience crafting intuitive, engaging digital experiences. I design clean, user-friendly interfaces and build responsive, high-quality UIs that balance aesthetics, usability, and performance.";
    // const backendContent = "Experienced backend developer with some Knowledge of 4 months in industrial settings, adept at crafting robust and scalable solutions. I specialize in designing and implementing efficient backend systems to support diverse applications. A quick learner with a passion for solving complex challenges, I bring a dedicated and collaborative approach to every project. Eager to contribute my skills and continue evolving in the dynamic field of backend development.";
    const heartIcon = <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="red" className="bi bi-heart-pulse-fill text-danger" viewBox="0 0 16 16">
        <path d="M1.475 9C2.702 10.84 4.779 12.871 8 15c3.221-2.129 5.298-4.16 6.525-6H12a.5.5 0 0 1-.464-.314l-1.457-3.642-1.598 5.593a.5.5 0 0 1-.945.049L5.889 6.568l-1.473 2.21A.5.5 0 0 1 4 9z" />
        <path d="M.88 8C-2.427 1.68 4.41-2 7.823 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C11.59-2 18.426 1.68 15.12 8h-2.783l-1.874-4.686a.5.5 0 0 0-.945.049L7.921 8.956 6.464 5.314a.5.5 0 0 0-.88-.091L3.732 8z" />
    </svg>
    const frontIcon = <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="red" className="bi bi-chevron-bar-expand text-danger" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M3.646 10.146a.5.5 0 0 1 .708 0L8 13.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708m0-4.292a.5.5 0 0 0 .708 0L8 2.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8" />
    </svg>

    return (
        <>
            <Container className=''>
                {/* ui ux */}
                <Container className='skillsBox'>
                    <Row className='homeSection'>
                        <Col lg={10} md={12} className='rightSection'>
                            <h4 className=' text-center'>
                                {frontIcon} UI Development <span className='text-dark'>|</span> {heartIcon} UI/UX Crafting Skills
                            </h4>
                            <br />
                            <p className='text-center '>
                                {aboutContent}
                            </p>
                        </Col>
                     
                    </Row>
                    <Row className='homeSection '>
                        <Col className='leftSection'>
                            <div className=''>
                                <div className="multiRow">

                                    {/* Row 1 */}
                                    <Marquee speed={40} gradient={false} gradientWidth={80}>
                                        <div className="bagdeWrapper">
                                            <Badge bg="primary">Figma</Badge>
                                            <Badge bg="success">Adobe XD</Badge>
                                            <Badge bg="danger">Adobe Illustrator</Badge>
                                            <Badge bg="warning" text="dark">Canva</Badge>
                                            <Badge bg="info">Wireframing</Badge>
                                            <Badge bg="dark">Prototype</Badge>
                                            <Badge bg="warning" text="dark">Adaptive UI</Badge>
                                        </div>
                                    </Marquee>

                                    {/* Row 2 */}
                                    <Marquee speed={35} gradient={false} gradientWidth={80} direction="right">
                                        <div className="bagdeWrapper">
                                            <Badge bg="primary">Flow Charts</Badge>
                                            <Badge bg="success">Low Fidelity Designs</Badge>
                                            <Badge bg="danger">Responsive Design</Badge>
                                            <Badge bg="primary">User Journey</Badge>
                                            <Badge bg="dark">Branding</Badge>
                                            <Badge bg="success">Customer Journey</Badge>

                                        </div>
                                    </Marquee>
                                      <Marquee speed={40} gradient={false} gradientWidth={80} >
                                        <div className='bagdeWrapper'>
                                            <Badge bg="primary">HTML/HTML5</Badge>
                                            <Badge bg="danger">CSS/CSS3</Badge>
                                            <Badge bg="info">Bootstrap/ React Bootstrap</Badge>
                                            <Badge bg="dark">JavaScript</Badge>
                                            <Badge bg="primary">React.js</Badge>
                                            <Badge bg="danger">Next.js</Badge>
                                            <Badge bg="success">TypeScript</Badge>
                                        </div>
                                    </Marquee>


                                    {/* Row 3 */}
                                    <Marquee speed={45} gradient={false} gradientWidth={80} direction="right" >
                                        <div className='bagdeWrapper'>
                                            <Badge bg="danger">SCSS</Badge>
                                            <Badge bg="warning" text="dark">Tailwind CSS</Badge>
                                            <Badge bg="dark">Material UI</Badge>
                                            <Badge bg="primary">Next UI</Badge>
                                            <Badge bg="dark">Chakra UI</Badge>
                                            <Badge bg="danger">Admin dashboards</Badge>
                                        </div>
                                    </Marquee>

                                </div>
                            </div>
                        </Col>

                        {/* <div className='skillHeading'> </div> */}
                    </Row>

                  
                </Container>
            </Container>
        </>
    );
}

export default Skills;